import { clientDetailEpics as epic } from './epics'
import { clientDetailReducer as reducer } from './reducer'

export const clientDetailEpic = epic
export const clientDetailReducer = reducer
